import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { AssetDto, AssetVideoTypeDataDto } from '@nusign/picflow-backend-types';
import { firstValueFrom } from 'rxjs';
import { AssetPageDataService } from '../../gallery/services/asset-page-data.service';
import { calcResizedUrl } from '../../lib/calc-resized-url';
import { PICFLOW_CONFIG } from '../../picflow-config';
import { GalleryService } from '../../services/gallery.service';

const calcUuid = (asset: AssetDto) => {
  if (asset.type !== 'video') {
    return asset.version_data.uuid;
  }

  const posterUrl = (asset.version_data?.data as AssetVideoTypeDataDto)?.poster_url;
  if (!posterUrl) return;
  return posterUrl.split('/base/')[1].split('.')[0];
};

export const publicAssetPageImageUrlResolver: ResolveFn<string> = async route => {
  const galleryService = inject(GalleryService);
  const assetPageDataService = inject(AssetPageDataService);
  const config = inject(PICFLOW_CONFIG);

  const gallery = await galleryService.getPublicGalleryFromSnapshot(route);
  const assetId = route.params.assetId.replace('}', '');
  const resp = await firstValueFrom(assetPageDataService.get(gallery, assetId, route.queryParams));

  if (!resp?.asset) return;

  const uuid = calcUuid(resp.asset);

  return calcResizedUrl(config.assetsEndpoint, uuid, `${1200}x${630}q${85}`);
};
